import { render, staticRenderFns } from "./InitialAssessment.vue?vue&type=template&id=192c526c&scoped=true"
import script from "./InitialAssessment.vue?vue&type=script&lang=js"
export * from "./InitialAssessment.vue?vue&type=script&lang=js"
import style0 from "./InitialAssessment.vue?vue&type=style&index=0&id=192c526c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192c526c",
  null
  
)

export default component.exports